import React from 'react';
import styled from 'styled-components';
import { WarningSign } from '../Icons';
const Styles = styled.span `
  display: flex;
  align-items: center;
  margin-top: 5px;
  color: ${(props) => props.theme.red};
  font-size: ${(props) => props.theme.fontSmall};
  .warning-sign {
    margin-right: 8px;
  }
`;
const ErrorMessage = ({ className, message }) => (React.createElement(Styles, { className: className },
    React.createElement(WarningSign, { className: "warning-sign" }),
    message));
export default ErrorMessage;
